// src/components/user/UserCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import FollowButton from './FollowButton';

const UserCard = ({ user, showBio = true, showStats = true, showFollowButton = true, onFollowChange, onUserSelect }) => {
  const handleCardClick = () => {
    if (onUserSelect) {
      onUserSelect(user);
    }
  };

  return (
    <div 
      className={`bg-white rounded-lg shadow-sm p-4 border border-gray-100 hover:shadow-md transition-shadow ${onUserSelect ? 'cursor-pointer' : ''}`}
      onClick={onUserSelect ? handleCardClick : undefined}
    >
      <div className="flex items-start">
        {/* User avatar */}
        <Link 
          to={`/profile/${user._id}`} 
          className="flex-shrink-0"
          onClick={(e) => onUserSelect && e.preventDefault()}
        >
          <div className="w-12 h-12 rounded-full overflow-hidden">
            <img 
              src={`${process.env.REACT_APP_ASSETS_URL}/uploads/profile/${user.avatar || 'default-avatar.png'}`} 
              alt={user.name}
              className="w-full h-full object-cover" 
            />
          </div>
        </Link>
        
        {/* User info */}
        <div className="ml-3 flex-1 min-w-0">
          <Link 
            to={`/profile/${user._id}`}
            className="font-medium text-gray-900 hover:text-primary transition-colors flex items-center"
            onClick={(e) => onUserSelect && e.preventDefault()}
          >
            <h4 className="truncate">{user.name}</h4>
            {user.isVerified && (
              <span className="flex items-center justify-center ml-1 w-4 h-4 bg-blue-500 rounded-full text-white text-xs">
                ✓
              </span>
            )}
          </Link>
          
          {showBio && user.bio && (
            <p className="text-sm text-gray-500 mt-1 line-clamp-2">{user.bio}</p>
          )}
        </div>
        
        {/* Follow button */}
        {showFollowButton && (
          <div className="ml-2 flex-shrink-0">
            <FollowButton 
              userId={user._id} 
              initialStatus={user.followInfo?.status}
              onFollowChange={(isFollowing, status) => {
                if (onFollowChange) {
                  onFollowChange(isFollowing, status);
                }
              }}
            />
          </div>
        )}
      </div>
      
      {/* User stats */}
      {showStats && (
        <div className="flex justify-around mt-4 pt-3 border-t border-gray-100">
          <div className="text-center">
            <span className="block text-sm font-semibold text-gray-900">{user.posts || 0}</span>
            <span className="text-xs text-gray-500">Posts</span>
          </div>
          
          <div className="text-center">
            <span className="block text-sm font-semibold text-gray-900">{user.followers || 0}</span>
            <span className="text-xs text-gray-500">Followers</span>
          </div>
          
          <div className="text-center">
            <span className="block text-sm font-semibold text-gray-900">{user.following || 0}</span>
            <span className="text-xs text-gray-500">Following</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserCard;